export const getProductionCapacityList = state => {
    return state.list
}

export const getProductionCapacityDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/productionCapacity/getters.js